
import { EmptyState } from 'v2/shared/components/empty-state'
import { formatCurrency } from 'v2/shared/utils'
import { useAppNavigate } from 'v2/shared/hooks/use-app-navigate'

interface BalanceWarningPopoverContentProps {
  balance: number
  currency: string
  hasError: boolean
  onClose: () => void
}

export const BalanceWarningPopoverContent = ({
  balance,
  currency,
  hasError,
  onClose,
}: BalanceWarningPopoverContentProps) => {
  const navigate = useAppNavigate()

  if (hasError) {
    return (
      <div className="w-80 p-4 pb-8">
        <EmptyState
          type="app_error"
          text="Unable to fetch balance. Please try again in some time."
          className="h-40 text-center"
        />
      </div>
    )
  }

  const isZeroOrNegative = balance <= 0

  const handleAction = () => {
    if (isZeroOrNegative) {
      navigate('/billing/overview')
    }
    onClose()
  }

  const buttonText = isZeroOrNegative ? 'Recharge' : 'Close'
  const actions = [
    {
      text: buttonText,
      onClick: handleAction,
      variant: isZeroOrNegative ? ('default' as const) : ('outline' as const),
      size: 'sm',
    },
  ]

  return (
    <div className="w-80 p-4 h-60">
      <EmptyState
        type="no_balance"
        text={
          <div className="text-center mt-8">
            <div className="text-p-600 text-primary">
              Current balance: {formatCurrency(balance, currency)}
            </div>
            <div className="mt-1 text-secondary">Recharge your account to start testing agents</div>
          </div>
        }
        actions={actions}
        className="pt-8"
      />
    </div>
  )
}
